<template>
    <div>
        <div
                style="position: relative; z-index: 5"
                v-if="type === 'content'"
                class="action-button requirement info-btn"
                @click="showCompatibilities"
                :title="t.frontend.compatibility_notes"
        >
            <span class="new-icon info"></span>
        </div>
        <div
                style="position: relative; z-index: 5"
                v-if="authUser"
                class="action-button add"
                :class="{ 'is-added': isAddedInternal }"
                @click="toggleAdd"
                :title="isAddedInternal ? t.frontend.remove_favorite : t.frontend.add_favorite"
        >
            <span class="new-icon star"></span>
        </div>
        <div
                v-if="type === 'package' && authUser"
                class="action-button fav"
                :class="{ 'is-fav': isFavInternal }"
                @click="toggleFav"
                :title="isFavInternal ? t.buttons.unlike : t.buttons.like"
        >
            <i class="icon" :class="actions.fav.icon"></i>
        </div>
        <CompatibilityPopup
                v-if="isCompatibilitiesPopupOpen"
                @close="closeCompatibilities"
                :contentId="id"
        ></CompatibilityPopup>
        <BasePopup v-if="isLoginPopupOpen" @close="isLoginPopupOpen = false" class="tutkitpopup612">
            <div>
                <h3>{{ t.popup.fav_content_title }}</h3>
                <h4>
                    <b>{{ t.popup.fav_content_subtitle }}</b>
                </h4>
                <p>{{ t.popup.fav_content_text }}.</p>

                <div class="button-bar">
                    <BaseButton type="high" color="alternate" target="_direct" @click.prevent="routeRegister">
                        {{ t.buttons.register }}
                    </BaseButton>
                    <BaseButton type="high" @click.prevent="routeLogin">{{ t.buttons.login }}</BaseButton>
                </div>
            </div>
        </BasePopup>
    </div>
</template>

<script>
import { usePackageStore } from "@/frontend/package-store.ts"
import BasePopup from "@/components/Frontend/BasePopup.vue"
import CompatibilityPopup from "@/components/Frontend/CompatibilityPopup.vue"
import BaseButton from "@/components/Buttons/BaseButton.vue"
import { openLoginRegistrationPopup } from "@/libs/helpers.ts"

const translationsData = window.translationsData

export default {
    components: {BasePopup, CompatibilityPopup, BaseButton},
    props: [
        "id",
        "is-fav",
        "is-added",
        "route-actions",
        "callback-fav",
        "callback-add",
        "has-underlying-link",
        "type",
    ],
    data() {
        return {
            isAddedInternal: false,
            isFavInternal: false,
            actions: {
                fav: {
                    icon: "icon-like"
                }
            },
            isPopupOpen: false,
            isCompatibilitiesPopupOpen: false,
            isLoginPopupOpen: false,
            packageStore: usePackageStore(),
            authUser: false,
            content: null,
            t: translationsData.translations
        }
    },
    async created() {
        this.isAddedInternal = this.isAdded || false
        this.isFavInternal = this.isFav || false
        await this.packageStore.fetchPackageContentsData()
        this.authUser = this.packageStore.getAuthUser()
        this.content = this.packageStore.getContentById(this.id)
        this.createListeners()
        window.addEventListener("keyup", this.closeOnESC)
        window.eventBus &&
        window.eventBus.$on("apply_is_fav", (type, id, value) => {
            if (type !== this.type || id != this.id) {
                return
            }

            this.isFavInternal = value
            this.$forceUpdate()
        })

        window.eventBus &&
        window.eventBus.$on("apply_is_added", (type, id, value) => {
            if (type !== this.type || id != this.id) {
                return
            }

            this.isAddedInternal = value
            this.$forceUpdate()
        })
    },
    destroyed() {
        window.removeEventListener("keyup", this.closeOnESC)
    },
    methods: {
        routeLogin() {
            this.isLoginPopupOpen = false
            openLoginRegistrationPopup()
        },
        routeRegister() {
            this.isLoginPopupOpen = false
            openLoginRegistrationPopup("registration")
        },
        showCompatibilities(event) {
            event.stopPropagation()
            this.isCompatibilitiesPopupOpen = true
        },
        closeCompatibilities() {
            this.isCompatibilitiesPopupOpen = false
        },
        async toggleAdd(event) {
            event.stopPropagation()

            if (!this.authUser) {
                this.isLoginPopupOpen = true
                return
            }

            try {
                window.eventBus && window.eventBus.$emit("apply_is_added", this.type, this.id, !this.isAddedInternal)
            } catch (error) {
                console.error(error)
            }
        },
        async toggleFav(event) {
            event.stopPropagation()

            if (!this.authUser) {
                this.isLoginPopupOpen = true
                return
            }

            try {
                window.eventBus && window.eventBus.$emit("apply_is_fav", this.type, this.id, !this.isFavInternal)
            } catch (error) {
                console.error(error)
            }
        },
        createListeners() {
            this.$root.$on("apply_is_added", (type, id, value) => {
                if (type !== this.type || id != this.id) {
                    return
                }

                this.isAddedInternal = value
            })

            this.$root.$on("apply_is_fav", (type, id, value) => {
                if (type !== this.type || id != this.id) {
                    return
                }

                this.isFavInternal = value
            })
        },
        closeOnESC(event) {
            if (parseInt(event.keyCode) === 27) {
                this.isPopupOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content-actions-buttons {
  display: flex;
  align-items: center;
  justify-self: end;
  margin-left: 15px;

  & > div:not(:first-child) {
    margin-left: 15px;
  }

  & > div.popup {
    margin-left: 0;
  }

  .action-button {
    border-radius: 100px;
    width: 20px;
    height: 20px;
    background-color: var(--color-light-grey);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 0 0 3px var(--color-grey-icon-outline);
    transition: 0.3s;

    &.is-added {
      background-color: var(--color-primary);
    }

    &.is-fav {
      background-color: var(--color-error);
    }

    &:not(.main):hover {
      background-color: var(--color-primary);
    }

    .icon {
      fill: var(--color-white);
      font-size: 24px;
    }

    &.requirement,
    &.fav {
      color: var(--color-white);
    }
  }

  .new-icon.star {
    margin-top: -1px;
  }
}
</style>
